import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../utils/baseURL";
import { setAlert } from "./alert.slice";
import axiosInstance from "../../utils/axiosInstance";
import Cookies from 'js-cookie';

const initialStatesideBar = {
    sidebar: [],
    success: false,
    message: '',
    loading: false,
};

const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    dispatch(setAlert({ text: errorMessage, color: 'error' }));
    return rejectWithValue(error.response?.data || { message: errorMessage });
};

export const getsidebar = createAsyncThunk(
    'sidebar/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/AllSlideBarCategory', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            // console.log("1111", response.data);
            return response.data.sidebar;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const AllSlideBarCategoryByAdmin = createAsyncThunk(
    'AllSlideBarCategoryByAdmin/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/AllSlideBarCategoryByAdmin', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            // console.log("2222", response.data);
            dispatch(getsidebar());
            return response.data.sidebar;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const slideBarCategory = createAsyncThunk(
    'slideBarCategory/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/slideBarCategory', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.sidebar;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const addsidebar = createAsyncThunk(
    'sidebar/add',
    async (data, { dispatch, rejectWithValue }) => {
        try {
            const { subsidebaradd, subcategoryimages, ...rest } = data;
            const formData = new FormData();

            formData.append('subsidebaradd', JSON.stringify(subsidebaradd));

            Object.keys(rest).forEach(key => {
                if (Array.isArray(rest[key])) {
                    rest[key].forEach(item => {
                        formData.append(key, item);
                    });
                } else {
                    formData.append(key, rest[key]);
                }
            });

            if (subcategoryimages) {
                subcategoryimages.forEach((file, index) => {
                    if (file instanceof File) {
                        formData.append('subcategoryimages', file);
                        formData.append(`subcategoryimagesIndex_${formData.getAll('subcategoryimages').length - 1}`, index);
                    } else if (typeof file === 'string') {
                        formData.append(`Existingsubcategoryimages_${index}`, file);
                    }
                });
            }

            const response = await axiosInstance.post(BASE_URL + '/creatSlidebarCategory', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(getsidebar());
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            return response.data.sidebar;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const deletesidebar = createAsyncThunk(
    'sidebar/delete',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(`${BASE_URL}/deleteSlideBarCategory/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            return id;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const currentsidebar = createAsyncThunk(
    'sidebar/currentsidebar',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get('/AllSlideBarCategory', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            console.log("responseresponseresponseresponse", response.data);
            return response.data.sidebar;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const editsidebar = createAsyncThunk(
    'sidebar/edit',
    async (data, { dispatch, rejectWithValue }) => {
        console.log("update", data);

        try {
            const { _id, subsidebaradd, subcategoryimages, ...rest } = data;
            const formData = new FormData();
            formData.append('_id', _id);

            formData.append('subsidebaradd', JSON.stringify(subsidebaradd));

            Object.keys(rest).forEach(key => {
                if (Array.isArray(rest[key])) {
                    rest[key].forEach(item => {
                        formData.append(key, item);
                    });
                } else {
                    formData.append(key, rest[key]);
                }
            });

            if (subcategoryimages) {
                subcategoryimages.forEach((file, index) => {
                    if (file instanceof File) {
                        // New file
                        formData.append('subcategoryimages', file);
                        formData.append(`subcategoryimagesIndex_${formData.getAll('subcategoryimages').length - 1}`, index);
                    } else if (typeof file === 'string') {
                        // Existing file path
                        formData.append(`Existingsubcategoryimages_${index}`, file);
                    }
                });
            }

            const response = await axiosInstance.put(`${BASE_URL}/updateSlideBarCategory/${_id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getsidebar());
            return response.data.sidebar;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);




const sideBarSlice = createSlice({
    name: 'sidebar',
    initialState: initialStatesideBar,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getsidebar.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching sideBar...';
            })
            .addCase(getsidebar.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'sideBar fetched successfully';
                state.sidebar = action.payload; // Ensure this is the correct payload
            })
            .addCase(getsidebar.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch sideBar';
            })
            .addCase(AllSlideBarCategoryByAdmin.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching sideBar...';
            })
            .addCase(AllSlideBarCategoryByAdmin.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'sideBar fetchediioo successfully';
                state.sidebar = action.payload; // Ensure this is the correct payload
            })
            .addCase(AllSlideBarCategoryByAdmin.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch sideBar';
            })
            .addCase(slideBarCategory.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching sideBar...';
            })
            .addCase(slideBarCategory.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'sideBar fetched successfully';
                state.sidebar = action.payload; // Ensure this is the correct payload
            })
            .addCase(slideBarCategory.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch sideBar';
            })
            .addCase(currentsidebar.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.currsidebar = action.payload;
            })
            .addCase(addsidebar.pending, (state) => {
                state.loading = true;
                state.message = 'Adding sidebar...';
            })
            .addCase(addsidebar.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.sidebar.push(action.payload);
                state.message = action.payload?.message || 'sidebar added successfully';
            })
            .addCase(addsidebar.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to add sidebar';
            })
            .addCase(deletesidebar.pending, (state) => {
                state.loading = true;
                state.message = 'Deleting sidebar...';
            })
            .addCase(deletesidebar.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.sidebar = state.sidebar.filter((sidebar) => sidebar._id !== action.payload);
                state.message = action.payload?.message || 'sidebar deleted successfully';
            })
            .addCase(deletesidebar.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to delete sidebar';
            })
            .addCase(editsidebar.pending, (state) => {
                state.loading = true;
                state.message = 'Editing sidebar...';
            })
            .addCase(editsidebar.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.sidebar = state.sidebar.map(sidebar =>
                    sidebar?._id === action.payload?._id ? action.payload : sidebar
                );
                state.message = action.payload?.message || 'sidebar updated successfully';
            })
            .addCase(editsidebar.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update sidebar';
            });
    }
});

export default sideBarSlice.reducer;